/**
 * FormData file helpers — same pattern as WorkerOnBoarding (repeat field key per file).
 */
export function appendOne(fd, key, f) {
  if (!f) return;
  if (f instanceof File || f instanceof Blob) {
    fd.append(key, f, (f && f.name) || undefined);
    return;
  }
  if (typeof FileList !== "undefined" && f instanceof FileList) {
    Array.from(f).forEach((ff) => fd.append(key, ff, ff.name));
    return;
  }
  if (Array.isArray(f)) {
    f.forEach((item) => appendOne(fd, key, item));
    return;
  }
  if (f && f.file) {
    appendOne(fd, key, f.file);
  }
}

export function appendMany(fd, key, arr) {
  (arr || []).forEach((item) => appendOne(fd, key, item));
}

/**
 * Backend client-onboarding DTO: ownershipControlDeclaration JSON (no File objects).
 * ownershipEntries: { name, percentageOfOwnership } with percentage as string.
 */
export function buildWireOwnershipControlDeclaration(occ, options = {}) {
  const { forUpdate = false } = options;
  const directors = (occ.directors || []).map((d) => ({
    fullName: (d.fullName || "").trim(),
  }));

  const summaryParts = directors.map((d) => d.fullName).filter(Boolean);
  const directorsOrBeneficialOwners = summaryParts.join("; ");

  const rawMode = occ.ownershipCompanyType;
  const mode = rawMode === "individual" ? "individuals" : rawMode;
  const sourceRows =
    mode === "corporate"
      ? occ.corporateUltimateOwners || []
      : occ.individualOwners || [];

  const ownershipEntries = (sourceRows || [])
    .map((row) => {
      const name = (row.fullName || "").trim();
      const pct = Number(row.percentageOfOwnership);
      if (!name || Number.isNaN(pct)) return null;
      return {
        name,
        percentageOfOwnership: String(pct),
      };
    })
    .filter(Boolean);

  const wire = {
    directorsOrBeneficialOwners,
    ownershipEntries,
    ownershipCompanyType: mode || undefined,
  };

  if (!forUpdate) {
    wire.confirmed = !!occ.confirmed;
  }

  return wire;
}
